import { useSelector } from "react-redux";

export default function useBrandInfo(propertyName) {
  const { basicBrandInfo } = useSelector((state) => state.InfauqeInstance);
  return basicBrandInfo[propertyName];
}
